// extracted by mini-css-extract-plugin
export default {"container":"styles_container__UwqDZ","content":"styles_content__0aexR"};